<template>
  <f7-page
    ptr
    @ptr:refresh="refreshData"
    @page:reinit="getList"
    infinite
    :infinite-distance="50"
    :infinite-preloader="showPreloader"
    @infinite="loadMore">
    <f7-navbar :no-shadow="true">
      <f7-nav-left
        color-theme="white"
        back-link="返回"
        back-link-url="/bid/list">
      </f7-nav-left>
      <f7-nav-title>工友招募</f7-nav-title>
    </f7-navbar>
    <div class="has-content" style="text-align: center;" v-if="workerList.length === 0">
      暂无工友招募信息
    </div>
    <div v-else>
      <div class="has-content"></div>
      <div v-for="(item, index) in workerList" :key="item.id">
        <div class="has-content" style="padding-top: 0rem; padding-bottom: 0rem;">
          <bid-worker :worker="item" personType="workmate"></bid-worker>
        </div>
        <div class="divider-row" v-if="index !== workerList.length - 1"></div>
      </div>
    </div>
  </f7-page>
</template>
<script>
import { getBidWorkerList } from '@/api/bid';
import BidWorker from '@/components/BidWorker';

export default {
  components: {
    BidWorker,
  },
  data() {
    return {
      workerList: [],
      pageObj: { page: 1, pageSize: 10 },
      allowInfinite: true,
      showPreloader: true,
    };
  },
  created() {
    this.getList();
  },
  methods: {
    refreshData(event, done) {
      Promise.all([this.getList()]).then(() => done());
    },
    getList(pageParam) {
      this.pageObj = pageParam || { page: 1, pageSize: 10 };
      getBidWorkerList(this.pageObj).then((result) => {
        if (result.code === 0) {
          if (this.pageObj.page === 1) {
            this.workerList = result.data || [];
          } else {
            (result.data || []).forEach((item) => {
              const pos = this.workerList.findIndex(w => w.id === item.id);
              if (pos < 0) {
                this.workerList.push(item);
              } else {
                this.workerList.splice(pos, 1, item);
              }
            });
          }
          this.allowInfinite = true;
          if (this.workerList.length < 10 || (result.data || []).length === 0) {
            this.showPreloader = false;
            this.allowInfinite = false;
          }
        }
      });
    },
    loadMore() {
      if (!this.allowInfinite) {
        return;
      }
      this.allowInfinite = false;
      if (this.workerList.length >= 100) {
        this.showPreloader = false;
        return;
      }
      this.$set(this.pageObj, 'page', this.pageObj.page + 1);
      this.getList(this.pageObj);
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '~@/style/app-var.scss';

  .divider-row {
    font-size: 0.5rem;
    height: 0.5rem;
    width: 100%;
  }

</style>



// WEBPACK FOOTER //
// src/pages/bid/workerList.vue